import classNames from 'classnames'
import {
  AiFillEye,
  AiFillEyeInvisible,
  AiOutlineCloudDownload,
  AiOutlineDelete,
  AiOutlineDownCircle,
  AiOutlineEdit,
  AiOutlineExport,
  AiOutlineEye,
  AiOutlineEyeInvisible,
  AiOutlineLogout,
  AiOutlineSwap
} from 'react-icons/ai'
import { BiCalendarX, BiCaretDown, BiLink, BiMenuAltLeft, BiUnlink } from 'react-icons/bi'
import {
  BsBoxSeam,
  BsCardText,
  BsDash,
  BsDashCircleDotted,
  BsDashLg,
  BsFillShieldLockFill,
  BsLightningFill,
  BsList,
  BsLock,
  BsMoon,
  BsQrCode,
  BsSimSlash,
  BsSun,
  BsUnlock2
} from 'react-icons/bs'
import { CiCalendar, CiFolderOn, CiHashtag, CiImageOn, CiTempHigh } from 'react-icons/ci'
import { FaEye, FaQuestion, FaSimCard, FaUser } from 'react-icons/fa'
import { FaFileCsv, FaUsers } from 'react-icons/fa6'
import { GoArrowRight, GoArrowUpLeft, GoArrowUpRight, GoCircleSlash, GoNote, GoSidebarExpand, GoStack, GoTasklist } from 'react-icons/go'
import { GrInProgress } from 'react-icons/gr'
import { HiLink, HiOutlineQrcode } from 'react-icons/hi'
import { HiMiniDeviceTablet, HiOutlineServerStack } from 'react-icons/hi2'
import { ImHome, ImLocation, ImStack } from 'react-icons/im'
import { IoIosCheckmark, IoIosSearch, IoMdCheckmarkCircleOutline, IoMdCopy } from 'react-icons/io'
import {
  IoAddSharp,
  IoCheckmarkDone,
  IoChevronDownSharp,
  IoCloseCircleOutline,
  IoCloseOutline,
  IoCropOutline,
  IoGridOutline,
  IoHardwareChipOutline,
  IoInformationOutline,
  IoKeypad,
  IoMedicalOutline,
  IoNotificationsOutline,
  IoPlay,
  IoPowerSharp,
  IoSettingsOutline,
  IoWarningOutline,
  IoWifi
} from 'react-icons/io5'
import { LuClock4, LuListRestart, LuPower, LuPowerOff } from 'react-icons/lu'
import {
  MdArrowBack,
  MdDashboard,
  MdFace,
  MdFingerprint,
  MdLogout,
  MdManageAccounts,
  MdOutlineArrowRightAlt,
  MdOutlineCellTower,
  MdOutlineClose,
  MdOutlineDashboard,
  MdOutlineEditOff,
  MdOutlineHistory,
  MdOutlineMail,
  MdOutlineModeEditOutline,
  MdOutlineWifiTethering,
  MdRestore,
  MdSettings,
  MdSignalCellularNoSim,
  MdSimCardAlert
} from 'react-icons/md'
import {
  PiCameraThin,
  PiCaretCircleDownLight,
  PiCaretCircleUpLight,
  PiCaretDoubleLeftBold,
  PiCaretLeftBold,
  PiCellSignalFullDuotone,
  PiInfo,
  PiNotepadBold,
  PiPaintBrushLight,
  PiShieldWarningLight,
  PiSquaresFourFill,
  PiStackPlusLight,
  PiWarning,
  PiWarningDiamondLight
} from 'react-icons/pi'
import {
  RiAddCircleLine,
  RiEditCircleFill,
  RiExpandLeftLine,
  RiIndeterminateCircleLine,
  RiMailSendLine,
  RiPushpinFill,
  RiRefreshLine,
  RiRemoteControlFill,
  RiSubtractFill,
  RiUnpinFill,
  RiUserSettingsLine
} from 'react-icons/ri'
import { RxReload, RxReset, RxTimer } from 'react-icons/rx'
import { SlFire, SlGlobe, SlOptions } from 'react-icons/sl'
import {
  TbCancel,
  TbCircleDashedNumber1,
  TbCircleDashedNumber2,
  TbEyeEdit,
  TbFaceId,
  TbFileImport,
  TbLoadBalancer,
  TbPlug,
  TbPlugOff,
  TbProgressDown,
  TbTemperatureCelsius
} from 'react-icons/tb'
import { TfiHelpAlt } from 'react-icons/tfi'
import { TiArrowRight, TiInfoLarge, TiPhoneOutline } from 'react-icons/ti'
import { VscArchive, VscArrowSwap, VscCircleFilled, VscCircuitBoard, VscGear, VscListFilter, VscTools } from 'react-icons/vsc'

import { MyMonitoringLogoOnly } from '@apps-common/components/common/logos/MyMonitoringLogoOnly'
import { FiZap } from 'react-icons/fi'

export const commonIcons = {
  // theme
  themeLight: BsSun,
  themeDark: BsMoon,
  themeSystem: VscCircleFilled,

  // my monitoring
  sites: ImHome,
  myMonitoringLogoOnly: (props: any) => <MyMonitoringLogoOnly {...props} />,

  // my monitoring event
  mmEventActivation: IoWarningOutline,
  mmEventFire: SlFire,
  mmEventMedical: IoMedicalOutline,
  mmEventOpen: BsUnlock2,
  mmEventClose: BsLock,
  mmEventPanic: PiShieldWarningLight,
  mmEventTimerTest: RxTimer,
  mmEventTrouble: PiWarningDiamondLight,
  mmEventInfo: PiInfo,

  // service requests
  srServerBalance: TbLoadBalancer,
  srServerChange: AiOutlineSwap,
  srMcChanges: VscArrowSwap,
  srActivations: MdOutlineWifiTethering,

  // unit activation
  activationReview: TbEyeEdit,
  activateNow: IoPlay,
  activateOnPowerUp: FiZap,

  // monitoring changes
  awaitingReview: GrInProgress,
  inReview: TbProgressDown,

  // toast
  toastInfo: IoInformationOutline,
  toastSuccess: IoIosCheckmark,
  toastWarning: PiWarning,
  toastError: PiWarning,

  // common
  camera: PiCameraThin,
  // settingsAdd: TbSettingsPlus,
  accountNo: CiHashtag,
  phone: TiPhoneOutline,
  email: MdOutlineMail,
  stack: ImStack,
  help: TfiHelpAlt,
  details: BsCardText,
  cellTowerSignal: MdOutlineCellTower,
  signalFull: PiCellSignalFullDuotone,
  crop: IoCropOutline,
  // email: TfiEmail,
  sendEmail: RiMailSendLine,
  export: AiOutlineExport,
  eye: AiOutlineEye,
  eyeInvisible: AiOutlineEyeInvisible,
  info: TiInfoLarge,
  indeterminateCircle: RiIndeterminateCircleLine,
  addCircle: RiAddCircleLine,
  themeBrush: PiPaintBrushLight,
  dashLg: BsDashLg,
  dash: BsDash,
  folder: CiFolderOn,
  profile: FaUser,
  filter: VscListFilter,
  menu: BiMenuAltLeft,
  dashboard: MdDashboard,
  settings: MdSettings,
  logout: MdLogout,
  add: IoAddSharp,
  addMultiple: PiStackPlusLight,
  link: HiLink,
  invisible: AiFillEyeInvisible,
  visible: AiFillEye,
  pin: ImLocation,
  outputSwitch: VscCircuitBoard,
  power: IoPowerSharp,
  powerAlt: LuPower,
  powerOffAlt: LuPowerOff,
  temp: CiTempHigh,
  tempCelsius: TbTemperatureCelsius,
  edit: AiOutlineEdit,
  editSimple: MdOutlineModeEditOutline,
  editOff: MdOutlineEditOff,
  editCircle: RiEditCircleFill,
  close: IoCloseOutline,
  closeCircle: IoCloseCircleOutline,
  caretDown: BiCaretDown,
  caretDownOutline: AiOutlineDownCircle,

  caretLeftBold: PiCaretLeftBold,
  caretDoubleLeftBold: PiCaretDoubleLeftBold,

  chevronDownSharp: IoChevronDownSharp,
  back: MdArrowBack,
  checkDouble: IoCheckmarkDone,
  check: IoIosCheckmark,
  checkCircle: IoMdCheckmarkCircleOutline,
  cancel: GoCircleSlash,
  cancelRestore: MdRestore,
  contactActions: LuListRestart,
  optionsHorizontal: SlOptions,
  archive: VscArchive,
  delete: AiOutlineDelete,
  management: MdManageAccounts,
  managementStack: GoStack,
  processSimCancellation: BsSimSlash,
  importFile: TbFileImport,
  csvFile: FaFileCsv,
  qrCode: HiOutlineQrcode,
  qrCodeUnitLabel: BsQrCode,
  download: AiOutlineCloudDownload,
  warning: IoWarningOutline,
  refresh: RiRefreshLine,
  reset: RxReset,
  reload: RxReload,
  arrowAngled: GoArrowUpRight,
  arrowAngledLeft: GoArrowUpLeft,
  arrowRight: GoArrowRight,
  arrowRightShort: TiArrowRight,
  processor: IoHardwareChipOutline,
  calendar: CiCalendar,
  calendarX: BiCalendarX,
  copy: IoMdCopy,
  search: IoIosSearch,
  users: FaUsers,
  schedule: LuClock4,
  trigger: BsLightningFill,
  zones: PiSquaresFourFill,
  notes: PiNotepadBold,
  note: GoNote,
  remove: MdOutlineClose,
  testOutput: RiRemoteControlFill,
  unknown: FaQuestion,
  image: CiImageOn,
  history: MdOutlineHistory,
  subtract: RiSubtractFill,
  sim: FaSimCard,
  eventList: BsList,

  // unit program task schedule
  unitProgramTaskSchedule: GoTasklist,

  // unit control
  armed: BsLock,
  disarmed: BsUnlock2,
  controlOn: TbPlug,
  controlOff: TbPlugOff,
  controlServiceGear: VscGear,
  control: RiRemoteControlFill,

  // unit
  pinUnit: RiPushpinFill,
  unPinUnit: RiUnpinFill,

  // unit status
  wifi: IoWifi,
  connected: BiLink,
  disconnected: BiUnlink,
  simNotCancelled: MdSimCardAlert,
  simCancelled: MdSignalCellularNoSim,

  // breadcrumbs
  breadcrumbArrowForward: MdOutlineArrowRightAlt,

  // sidebar
  sbExpand: GoSidebarExpand,
  sbShrink: RiExpandLeftLine,
  sbDashboard: MdOutlineDashboard,
  sbUnits: HiMiniDeviceTablet,
  sbOrders: (props: any) => <BsBoxSeam {...{ ...props, className: classNames('text-[0.9em]', props.className) }} />,
  sbServiceRequests: VscTools,
  sbReceivers: HiOutlineServerStack,
  sbNotifications: IoNotificationsOutline,
  sbSettings: IoSettingsOutline,
  sbManagement: RiUserSettingsLine,
  sbLogout: AiOutlineLogout,

  // biometric
  iris: FaEye,
  faceId: TbFaceId,
  faceAuthentication: MdFace,
  fingerprint: MdFingerprint,
  pincode: IoKeypad,
  multiAuth: BsFillShieldLockFill,

  // expand
  expandUp: PiCaretCircleUpLight,
  expandDown: PiCaretCircleDownLight,

  // receivers
  receiverAzUnknown: BsDashCircleDotted,
  receiverAzPrimary: TbCircleDashedNumber1,
  receiverAzSecondary: TbCircleDashedNumber2,
  receiverAz: SlGlobe,
  receiverAll: IoGridOutline,
  receiverOnline: IoMdCheckmarkCircleOutline,
  receiverDegraded: IoWarningOutline,
  receiverOffline: TbCancel
}

export type COMMON_ICONS_TYPE = keyof typeof commonIcons
